<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'terms-of-use' }"
          >Terms Of Use</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="display-2 font-weight-light mb-10 font-serif text-capitalize">
        Terms Of Use
      </div>

      <div class="d-flex my-6">
        <terms-form :terms="terms" />
      </div>
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  mdiChevronLeft,
  mdiCheck,
  mdiAlertCircleOutline,
  mdiAccountOff
} from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import TermsForm from '@/views/Home/TermsOfUse/components/TermsForm'

export default {
  name: 'TermDetails',

  components: {
    TermsForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline,
        block: mdiAccountOff
      },
      loading: false
    }
  },

  computed: {
    ...mapState({
      terms: state => state.support.termsDetails
    })
  },

  watch: {
    $route() {
      this.getTerms()
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getTermsDetails: 'support/getTermsDetails'
    }),

    ...mapMutations({
      clearTermsDetails: 'support/clearTermsDetails'
    }),

    async getTerms() {
      this.loading = true
      await this.getTermsDetails()
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          if (error.response && error.response.status === 403) {
            this.logout()
          }
        })
    }
  },

  created() {
    this.getTerms()
  },

  destroyed() {
    this.clearTermsDetails()
  }
}
</script>
